import React from 'react';
import { FAQProps } from './FAQProp';

const FAQs: React.FC<FAQProps> = ({
    title = "FAQ's",
    description = "",
    faqs,
}) => {
    return (
        <div className="flex-1 w-full">
            <div className="mb-12">
                <h2 className="text-5xl font-medium text-black-50 text-center">
                    {title}
                </h2>
                {description && (
                    <p className="text-neutral-100 max-w-[540px] text-base/6 text-center mx-auto mt-5">
                        {description}
                    </p>
                )}
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-y-0">
                {/* First Column */}
                <div className="space-y-4">
                    {faqs.slice(0, Math.ceil(faqs.length / 2)).map((item, index) => (
                        <details
                            key={index}
                            name="faq-accordion"
                            className="group rounded-lg border border-neutral-800 transition-all duration-300"
                        >
                            <summary className="flex cursor-pointer list-none bg-neutral-950 items-center justify-between gap-4 p-3.5 [&::-webkit-details-marker]:hidden">
                                <span className="text-md font-medium text-neutral-100">
                                    {item.question}
                                </span>
                                <div className="shrink-0 rounded p-1 text-neutral-100 transition-colors">
                                    <svg
                                        className="block group-open:hidden"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M5 12h14" />
                                        <path d="M12 5v14" />
                                    </svg>
                                    <svg
                                        className="hidden group-open:block"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M5 12h14" />
                                    </svg>
                                </div>
                            </summary>
                            <div className="grid grid-rows-[0fr] opacity-0 transition-all duration-300 ease-in-out group-open:grid-rows-[1fr] group-open:opacity-100">
                                <div className="overflow-hidden">
                                    <p className="p-5 text-md leading-relaxed text-black">
                                        {item.answer}
                                    </p>
                                </div>
                            </div>
                        </details>
                    ))}
                </div>

                {/* Second Column */}
                <div className="space-y-4">
                    {faqs.slice(Math.ceil(faqs.length / 2)).map((item, index) => (
                        <details
                            key={index}
                            name="faq-accordion"
                            className="group rounded-lg border border-neutral-800 transition-all duration-300"
                        >
                            <summary className="flex cursor-pointer list-none bg-neutral-950 items-center justify-between gap-4 p-3.5 [&::-webkit-details-marker]:hidden">
                                <span className="text-md font-medium text-neutral-100">
                                    {item.question}
                                </span>
                                <div className="shrink-0 rounded p-1 text-neutral-100 transition-colors">
                                    <svg
                                        className="block group-open:hidden"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M5 12h14" />
                                        <path d="M12 5v14" />
                                    </svg>
                                    <svg
                                        className="hidden group-open:block"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M5 12h14" />
                                    </svg>
                                </div>
                            </summary>
                            <div className="grid grid-rows-[0fr] opacity-0 transition-all duration-300 ease-in-out group-open:grid-rows-[1fr] group-open:opacity-100">
                                <div className="overflow-hidden">
                                    <p className="p-5 text-md leading-relaxed">
                                        {item.answer}
                                    </p>
                                </div>
                            </div>
                        </details>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FAQs;